import React from 'react';
import { M3ContainedCarouselOptimised } from '@/components/ui/M3ContainedCarouselOptimised';
import { MobileAllowedAreaSlide } from './MobileAllowedAreaSlide';
import type { AllowedAreas } from '@/features/booking/types/eventBookingCategoryTypes';

interface MobileAllowedAreaSectionProps {
  allowedAreas: AllowedAreas | null;
}

export const MobileAllowedAreaSection: React.FC<MobileAllowedAreaSectionProps> = ({ allowedAreas }) => {
  if (!allowedAreas || allowedAreas.length === 0) {
    return null;
  }

  const flattenedSlides = React.useMemo(() => {
    const slides: { area: typeof allowedAreas[0]; imageId: string }[] = [];
    allowedAreas.forEach((area) => {
      if (area.image_ids && area.image_ids.length > 0) {
        area.image_ids.forEach((imageId) => {
          slides.push({ area, imageId });
        });
      } else {
        slides.push({ area, imageId: '' });
      }
    });
    return slides;
  }, [allowedAreas]);

  return (
    <section className="w-full py-6 flex flex-col gap-4 border-b border-gray-800/60 bg-[#050505]">
      <div className="px-5">
         <h2 className="text-xl font-bold font-serif text-white tracking-tight">Accessible Areas</h2>
      </div>
      
      <div className="w-full pl-5 pr-5">
        {flattenedSlides.length >= 3 ? (
          <div className="-mr-5">
            <M3ContainedCarouselOptimised borderRadius={16} className="h-56" loop={true}>
              {flattenedSlides.map((slide, index) => (
                <MobileAllowedAreaSlide key={`slide-${index}`} area={slide.area} imageId={slide.imageId} />
              ))}
            </M3ContainedCarouselOptimised>
          </div>
        ) : (
          <div className="flex gap-4 overflow-x-auto pb-4 -mr-5 pr-5 snap-x snap-mandatory hide-scrollbars">
            {flattenedSlides.map((slide, index) => (
              <div 
                key={`slide-static-${index}`} 
                className="snap-center shrink-0 w-[85%] sm:w-[300px] h-56 rounded-2xl overflow-hidden"
              >
                <MobileAllowedAreaSlide area={slide.area} imageId={slide.imageId} />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
